import { handleSpecialCaseDetailArrays } from 'utils/tinyMCE/handleSpecialCaseDetailArrays'
import dynamicTextUtilities from './dynamicTextUtilities'
import { tableTemplate } from 'utils/tinyMCE/caseDetails'
import { load } from 'cheerio'
import preserveItalicsAndBolds from 'utils/tinyMCE/updateDynamicText/preserveItalicsAndBolds'
import {
  extractExistingTableCellStyles,
  restoreTableCellStyles,
  preserveTableDivStyling,
} from '@/utils/tinyMCE/updateDynamicText/updateCaseDetailTableHelpers'

// Toggle a cheerio node's visibility via an inline display:none — the same
// hidden-content convention the dynamic-text refresh already recognises
// (see dynamicTextUtilities isNodeHidden).
const hideNode = (node) => {
  if (!node || !node.length) return
  const style = node.attr('style') || ''
  if (/display:\s*none/i.test(style)) return
  const sep = style.trim() && !style.trim().endsWith(';') ? '; ' : ' '
  node.attr('style', `${style}${sep}display: none`.trim())
}

const showNode = (node) => {
  if (!node || !node.length) return
  const style = node.attr('style') || ''
  const cleaned = style
    .replace(/\s*display:\s*none\s*;?/gi, '')
    .replace(/;\s*$/, '')
    .trim()
  node.attr('style', cleaned)
}

export const updateCaseDetailTables = (dynamicTextProps) => {
  const { elementProps } = dynamicTextProps
  const { element } = elementProps

  const { getCaseDetail } = dynamicTextUtilities(dynamicTextProps)
  const { path, value } = getCaseDetail(element)

  // For honorary_pallbearers, merge names from the PallBearer relation
  // (type === 'honorary pallbearer') with the legacy honorary_pallbearers String[]
  let items
  if (path === 'honorary_pallbearers') {
    const { caseDetails } = dynamicTextProps.editorProps
    const relationHonorary = handleSpecialCaseDetailArrays({
      path: 'honorary_pallbearers_from_relation',
      items: caseDetails?.pallbearers,
    })
    const legacyHonorary = Array.isArray(value) ? value : []
    items = [...(relationHonorary || []), ...legacyHonorary]

    const headingNode = element.prev('[data-honorary-pallbearers-heading]')

    // When there are no honorary pallbearers, HIDE the heading + table instead
    // of removing them, so a later refresh can repopulate the same block when
    // honorary pallbearers are re-added to the case. Removing them left no
    // element for the refresh to find, so re-added honorary never came back.
    if (items.length === 0) {
      hideNode(headingNode)
      hideNode(element)
      return
    }

    // Honorary present: un-hide the heading AND the existing table div, so the
    // rebuilt table (which copies the div's saved style via
    // preserveTableDivStyling) doesn't inherit the hidden display:none state.
    showNode(headingNode)
    showNode(element)
  } else {
    items = handleSpecialCaseDetailArrays({ path, items: value })
  }

  const perCellStyles = extractExistingTableCellStyles(element)

  const tableHtml = tableTemplate({
    path,
    items,
    selectedTheme: dynamicTextProps.editorProps.selectedTheme,
    editor: dynamicTextProps.editorProps.editor,
  })

  const tableElement = load(tableHtml)

  restoreTableCellStyles(tableElement, perCellStyles)

  preserveItalicsAndBolds({
    initialElement: element,
    targetElement: tableElement,
    targetTag: 'td',
  })

  preserveTableDivStyling(element, tableElement)

  element.replaceWith(tableElement.html('body'))
}

export default updateCaseDetailTables
